import React from 'react';
import { History, FileText } from 'lucide-react';
import { AUDIT_ACTIONS } from './vaultConstants';

export function ActivityLogTab({ auditLogs }) {
  return (
    <div className="space-y-4" data-testid="activity-log-content">
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 flex items-start gap-3">
        <History className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="font-medium text-purple-800">Vault Activity Log</p>
          <p className="text-purple-700">
            Track all document uploads, downloads, edits, and executor changes for security and compliance.
          </p>
        </div>
      </div>

      {auditLogs.length === 0 ? (
        <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
          <History className="w-10 h-10 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-600 mb-2">No activity yet</p>
          <p className="text-sm text-gray-500">Activity will be logged as documents are uploaded and accessed</p>
        </div>
      ) : (
        <div className="space-y-2">
          {auditLogs.map((log, index) => {
            const actionInfo = AUDIT_ACTIONS[log.action] || { label: log.action, icon: FileText, color: 'text-gray-600' };
            const ActionIcon = actionInfo.icon;
            return (
              <div key={log.audit_id || index} className="flex items-start gap-3 p-3 bg-white rounded-lg border border-gray-200" data-testid={`audit-log-${log.audit_id}`}>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${actionInfo.color.replace('text-', 'bg-').replace('600', '100')}`}>
                  <ActionIcon className={`w-4 h-4 ${actionInfo.color}`} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-medium text-gray-900">{log.user_name}</span>
                    <span className={`text-sm ${actionInfo.color}`}>{actionInfo.label}</span>
                    {log.document_title && (
                      <span className="text-sm text-gray-600 truncate">"{log.document_title}"</span>
                    )}
                    {log.target_user_name && (
                      <span className="text-sm text-gray-600">{log.target_user_name}</span>
                    )}
                  </div>
                  {log.details && <p className="text-xs text-gray-500 mt-1">{log.details}</p>}
                  <p className="text-xs text-gray-400 mt-1">
                    {new Date(log.timestamp).toLocaleString('en-US', {
                      month: 'short', day: 'numeric', year: 'numeric',
                      hour: 'numeric', minute: '2-digit', hour12: true
                    })}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
